import React, { useRef, useEffect, useState } from 'react';
import { PreviewHTML, DataTable, Column } from 'vivace-fluent-motion';
import { useReactToPrint } from 'react-to-print';
import { useSelector, useDispatch } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as actions from '../store/relatorios.action';
import IntlMessage from '../../../../../helpers/intlMessage';
import DescarteApi from '../../../descarte.api';
import SepultamentoInividual from '../../../common/components/SepultamentoInividual';
import ModalIndicacao from '../../../modais/indicacao';

function GridSepultamentoIndividual ({ lista }) {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const { imprimir } = useSelector(state => state.descarteRelatorios);
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const [itemSelecionado, setItemSelecionado] = useState(undefined);
  const [listaItens, setListaItens] = useState([]);
  const [previewHTML, setPreviewHTML] = useState(false);
  const [showModalIndicacao, setShowModalIndicacao] = useState(false);
  const [indicacao, setIndicacao] = useState('');

  useEffect(() => {
    if (imprimir) {
      setIndicacao('');
      if (itemSelecionado) {
        setShowModalIndicacao(!showModalIndicacao);
        const indicacaoCorrente = itemSelecionado.indicacao || '';
        setIndicacao(indicacaoCorrente);
      } else {
        dispatch(actions.imprimir(false));
        dispatch(
          commonActions.showAlerta(
            'alerta',
            'Nenhum item foi selecionado',
            3000
          )
        );
      }
    }
  }, [imprimir]);

  useEffect(() => {
    setListaItens(lista);
  }, [lista]);

  function ComponentHTML ({ id }) {
    return (
      <div id={id} ref={componentRef} className='mv-visualizador-html'>
        <SepultamentoInividual data={itemSelecionado} />
      </div>
    );
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  function selectItem (e) {
    setItemSelecionado(e.value);
  }

  function salvarIndicacao () {
    dispatch(commonActions.showFadeCarregando(true));
    DescarteApi.atualizarIdicacao(Number(itemSelecionado.idMaterial), indicacao)
      .then(res => {
        setItemSelecionado({ ...itemSelecionado, indicacao });
        setShowModalIndicacao(false);
        setPreviewHTML(true);
        dispatch(actions.imprimir(false));
        dispatch(commonActions.showFadeCarregando(false));
        dispatch(commonActions.showAlerta('sucesso', res.message, 3000));

        const listaAlterada = lista.map(item => {
          return item.idMaterial === itemSelecionado.idMaterial
            ? { ...itemSelecionado, indicacao }
            : { ...item };
        });
        dispatch(actions.lista(listaAlterada));
      })
      .catch(() => {
        setShowModalIndicacao(false);
        dispatch(actions.imprimir(false));
        dispatch(commonActions.showFadeCarregando(false));
      });
  }

  return (
    <div>
      <PreviewHTML
        messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>} 
        printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
        visible={previewHTML}
        id='uniqueID'
        component={<ComponentHTML id='uniqueID' />}
        onOpened={e => setPreviewHTML(e)}
        onPrint={handlePrint}
      />
      <ModalIndicacao
        onModal={() => {
          setShowModalIndicacao(!showModalIndicacao);
          dispatch(actions.imprimir(false));
        }}
        indicacao={indicacao}
        setIndicacao={setIndicacao}
        showModalIndicacao={showModalIndicacao}
        imprimir={salvarIndicacao}
      />
      <DataTable
        onContextMenu={() => {}}
        value={listaItens}
        responsive={true}
        selectionMode='single'
        style={{ height: '100%' }}
        columnResizeMode='expand'
        scrollable={true}
        scrollHeight='50vh'
        scrollWidth='100%'
        resizableColumns={true}
        reorderableColumns={true}
        lazy={true}
        paginator={false}
        emptyMessage={<IntlMessage id = "dashboards.reports.noResultsFound"/>}
        totalRecords={listaItens.length}
        alwaysShowPaginator={true}
        autoLayout={true}
        selection={itemSelecionado}
        onSelectionChange={e => {
          selectItem(e);
        }}
      >
        <Column
          sortable={false}
          field='numeroExame'
          style={{ width: '200px' }}
          header={<IntlMessage id = "dashboards.reports.exam"/>}
        />

        <Column
          sortable={false}
          field='paciente'
          style={{ width: '300px' }}
          header={<IntlMessage id = "dashboards.reports.patientCivilRegistry"/>}
        />
        <Column
          sortable={false}
          field='pacienteNomeSocial'
          style={{ width: '300px' }}
          header={<IntlMessage id = "dashboards.reports.socialName"/>}
        />

        <Column
          field='nomeMaterial'
          style={{ width: '250px' }}
          header={<IntlMessage id = "dashboards.reports.material"/>}
        />
        <Column
          field='medicoResponsavelMacroscopia'
          style={{ width: '250px' }}
          header={<IntlMessage id = "dashboards.reports.doctorMacro"/>}
        />

        <Column
          field='medicoResponsavelDescarte'
          style={{ width: '300px' }}
          header={<IntlMessage id = "dashboards.reports.burialRequestingPhysician"/>}
        />
        <Column
          field='dataEntrega'
          style={{ width: '150px' }}
          header={<IntlMessage id = "dashboards.reports.deliveryDate"/>}
        />
      </DataTable>
    </div>
  );
}

export default GridSepultamentoIndividual;



// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/relatorios/GridSepultamentoIndividual/index.js